import styled from 'styled-components'

export const Row = styled.div<{ showDetails?: boolean }>`
    display: flex;
    align-items: center;
    height: 60px;
    background-color: ${({ showDetails }) => (showDetails ? 'var(--blue-200)' : 'var(--gray-0)')};
    transition: background-color 250ms;

    &:hover {
        background-color: var(--blue-200);
    }

    &:not(:last-child) {
        border-bottom: 1px solid ${({ showDetails }) => (showDetails ? 'transparent' : 'var(--gray-400)')};
    }

    &:last-child {
        border-radius: 0 0 2px 2px;
    }
    
    .feature-title {
        font-weight: 400;

        > .version {
            font-style: italic;
            font-weight: normal;
            padding-left: 5px;
        }

        > a {
            padding-left: 5px;
        }

        .fa-external-link.disabled {
            padding-left: 5px;
            opacity: 0.6;
            color: var(--gray-400);
        }
    }

    .perspective {
        display: flex;
        align-items: center;

        i {
            color: var(--yellow-700);
            z-index: 2;
            margin-left: -45px;
            pointer-events: none;
            font-size: 16px;
        }
    }

    .live-select {
        width: 280px;
        margin: 12px 0px;
    }

    .channels-cell {
        :not(:last-child) {
            border-right: 1px solid var(--gray-400);
        }
    }

    .chevron-toggle {
        margin: 0;
        border: 0;
        background: transparent;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: end;
        cursor: pointer;

        i {
            font-size: 16px;
        }

        &:focus-visible i {
            box-shadow: 0 0 0 3px var(--blue-400);
        }
    }
`

export const Readme = styled.div`
    width: 100%;
    padding: 0 15px 15px;
    background-color: var(--blue-200);
    font-size: 12px;

    &:not(:last-child) {
        border-bottom: 1px solid var(--gray-400);
    }
`

export const MarkdownContent = styled.div`
    && {
        > :first-child {
            margin-top: 0 !important;
        }

        > :last-child {
            margin-bottom: 0 !important;
        }

        p,
        ul,
        ol,
        blockquote,
        pre,
        td,
        th,
        li {
            font-size: 1em; /* equiv 12px */
            line-height: 1.5;
        }

        p,
        ul,
        ol,
        blockquote,
        pre {
            margin: 1.5em 0;
        }

        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
            font-family: var(--font-semibold);
            text-transform: none;
            color: inherit;
        }

        h1 {
            font-size: 2em;
            line-height: 1.5;
            margin: 0.75em 0;
        }

        h2 {
            font-size: 1.5em;
            line-height: 1;
            margin: 1em 0;
        }

        h3 {
            font-size: 1.25em;
            line-height: 1.2;
            margin: 1.2em 0;
        }

        h4 {
            font-size: 1em;
            line-height: 1.5;
            margin: 1.5em 0;
        }

        h5 {
            font-size: 0.9167em;
            line-height: 1.8;
            margin: 1.6364em 0;
        }

        h6 {
            font-size: 0.8333em;
            line-height: 2.25;
            margin: 1.8em 0;
        }

        ul,
        ol {
            padding-left: 1em;
        }

        ul ul,
        ul ol,
        ol ul,
        ol ol {
            margin-top: 0;
            margin-bottom: 0;
        }

        ul {
            list-style: disc;
        }

        ol {
            list-style: decimal;
        }

        code,
        pre {
            white-space: pre-wrap;
        }

        pre {
            border-radius: 5px;
            border: 1px solid;
            padding: calc(1em - 1px);
        }

        code {
            line-height: 1;
        }

        table {
            margin-bottom: 1.5em;
        }

        blockquote {
            border-left: 2px solid;
            padding-left: calc(1em - 2px);
            opacity: 0.75;
        }
    }
`

export const CardContent = styled.div`
    width: 100%;
    border: 1px solid var(--gray-400);
    border-radius: 3px;
    margin-bottom: 50px;
    font-size: 13px;

    .feature-table {
        width: 100%;
        margin: 0;

        .feature-table-head {
            display: flex;
            align-items: center;
            height: 20px;
            padding: 2px;
            background-color: var(--gray-200);
            border-bottom: 1px solid var(--gray-400);
            font-size: 10px;
            font-weight: 400;
            text-transform: uppercase;
        }
    }

    .title {
        font-weight: 600;
        padding: 12px 14px;
        background-color: var(--gray-200);
        border-bottom: 1px solid var(--gray-400);
        border-radius: 2px 2px 0 0;
        font-size: 14px !important;
        font-weight: 600;
        line-height: 16px;
        color: var(--gray-800);
        text-transform: uppercase;
    }

    .feature-warning {
        padding: 11px 18px 12px;
        font-size: 13px;
        background: var(--yellow-200);
        border-bottom: 1px solid var(--gray-400);
    }
`

export const Active = styled.span<{ color: string }>`
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    color: ${({ color }) => color};
`
